import React, { useState, useEffect } from 'react';
import { Bar } from 'react-chartjs-2';
import { Box, Slider } from "@mui/material";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels'; // Import the plugin
import "./style.css";

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, ChartDataLabels);

ChartJS.defaults.font.family = 'Futura PT';

// const StackedBarChart = ({ data, options }) => {
//   const [value, setValue] = useState(0);
//   const [chartOptions, setChartOptions] = useState(options);

//   // Configuration for columns
//   const noOfColumnToDisplay = 10;
//   const labelsLength = data.labels.length;
//   const noOfMaxForSlider = Math.max(0, labelsLength - noOfColumnToDisplay);

//   // Sync internal state if parent options change (initial load)
//   useEffect(() => {
//     const initialOpt = JSON.parse(JSON.stringify(options));
//     if (!initialOpt.scales.x) initialOpt.scales.x = {};
//     initialOpt.scales.x.min = 0;
//     initialOpt.scales.x.max = noOfColumnToDisplay - 1;
//     setChartOptions(initialOpt);
//   }, [options]);

//   const handleSliderChange = (event, newValue) => {
//     const newOpt = JSON.parse(JSON.stringify(chartOptions));

//     // Update the X-axis range based on slider value
//     newOpt.scales.x.min = newValue;
//     newOpt.scales.x.max = newValue + (noOfColumnToDisplay - 1);

//     setChartOptions(newOpt);
//     setValue(newValue);
//   };

//   return (
//     // <div style={{ position: 'relative', height: '100%', width: '100%' }}>
//     //   <Bar data={data} options={options} />
//     // </div>
//     <div style={{ height: '100%', width: '100%' }}>
//       <div style={{ height: '96%' }}>
//         <Bar data={data} options={chartOptions} />
//       </div>

//       {/* Slider appears only if data exceeds display limit */}
//       {labelsLength > noOfColumnToDisplay && (
//         <div style={{ padding: '0 20px', marginTop: '10px' }}>
//           <Slider
//             value={value}
//             onChange={handleSliderChange}
//             step={1}
//             min={0}
//             max={noOfMaxForSlider}
//             valueLabelDisplay="auto"
//             color="primary"
//           />
//         </div>
//       )}
//     </div>
//   );
// };

const StackedBarChart = ({ data, options, scrollDirection = 'forward' }) => {
  // Define default display settings
  const noOfColumnToDisplay = scrollDirection == 'backward' ? 6 : 8;
  const [sliderValue, setSliderValue] = useState(0);
  const [chartOptions, setChartOptions] = useState(options);

  const labelsLength = data.labels.length;
  const maxSliderValue = Math.max(0, labelsLength - noOfColumnToDisplay);

  // --- Core Logic: Initialize Chart View ---
  useEffect(() => {
    const initialOpt = JSON.parse(JSON.stringify(options));
    if (!initialOpt.scales.x) initialOpt.scales.x = {};

    // Conditional initial view logic
    if (scrollDirection === 'backward') {
      // Start at the latest data points (end of the array)
      initialOpt.scales.x.min = maxSliderValue;
      initialOpt.scales.x.max = labelsLength - 1;
      setSliderValue(maxSliderValue);
    } else {
      // Default to forward: Start at the beginning of the data
      initialOpt.scales.x.min = 0;
      initialOpt.scales.x.max = noOfColumnToDisplay - 1;
      setSliderValue(0);
    }

    setChartOptions(initialOpt);
  }, [options, data.labels.length, scrollDirection, maxSliderValue, labelsLength]);

  // --- Core Logic: Handle Slider Change ---
  const handleSliderChange = (event, newValue) => {
    const newOpt = JSON.parse(JSON.stringify(chartOptions));

    // The calculation remains the same regardless of direction
    newOpt.scales.x.min = newValue;
    newOpt.scales.x.max = newValue + (noOfColumnToDisplay - 1);

    setChartOptions(newOpt);
    setSliderValue(newValue);
  };

  return (
    <div style={{ height: '100%', width: '100%' }}>
      <div style={{ height: '96%' }}>
        <Bar data={data} options={chartOptions} />
      </div>

      {labelsLength > noOfColumnToDisplay && (
        <div style={{ padding: '0 20px' }}>
          <Slider
            value={sliderValue}
            onChange={handleSliderChange}
            step={1}
            min={0}
            max={maxSliderValue}
            valueLabelDisplay="auto"
            color="primary"
          />
        </div>
      )}
    </div>
  );
};

export default StackedBarChart;